<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baHerbalMedicine:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="中药编码">
                <a-input v-model="queryParam.medicinecode" allow-clear placeholder="请输入中药编码"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="中药名称">
                <a-input v-model="queryParam.medicinename" allow-clear placeholder="请输入中药名称"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="拼音简写">
                  <a-input v-model="queryParam.pinyin" allow-clear placeholder="请输入拼音简写"/>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :sm="24">
              <a-form-item label="来源">
                <a-select v-model="queryParam.channel" placeholder="请选择来源">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value='0'>his</a-select-option>
                  <a-select-option value='1'>管理后台</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            </template>
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.medicineid"
        :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator" v-if="hasPerm('baHerbalMedicine:add')" >
          <a-button type="primary" v-if="hasPerm('baHerbalMedicine:add')" icon="plus" @click="$refs.addForm.add()">新增草药信息表</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('baHerbalMedicine:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button>
          <x-down
            v-if="hasPerm('baHerbalMedicine:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a v-if="hasPerm('baHerbalMedicine:edit') && record.channel != 0" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('baHerbalMedicine:edit') & hasPerm('baHerbalMedicine:delete')"/>
          <a-popconfirm v-if="hasPerm('baHerbalMedicine:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import { baHerbalMedicinePage, baHerbalMedicineDelete, baHerbalMedicineExport } from '@/api/modular/interhospital/baherbalmedicine/baHerbalMedicineManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '中药编码',
            align: 'center',
            dataIndex: 'medicinecode'
          },
          {
            title: '中药名称',
            align: 'center',
            dataIndex: 'medicinename'
          },
          {
            title: '拼音简写',
            align: 'center',
            dataIndex: 'pinyin'
          },
          {
            title: '规格',
            align: 'center',
            dataIndex: 'specification'
          },
          {
            title: '剂型名称',
            align: 'center',
            dataIndex: 'dosename'
          },
          {
            title: '生产商名称',
            align: 'center',
            dataIndex: 'manuname'
          },
          {
            title: '单位（备选来源于数据字典的计量单位值集，取数据字典中valuename）',
            align: 'center',
            dataIndex: 'baseUnit'
          },
          {
            title: '剂量单位',
            align: 'center',
            dataIndex: 'mediUnit'
          },
          {
            title: '最小包装单位',
            align: 'center',
            dataIndex: 'packageUnitid'
          },
          {
            title: '最小包装单位名称',
            align: 'center',
            dataIndex: 'packageUnit'
          },
          {
            title: '最小包装单位转换系数',
            align: 'center',
            dataIndex: 'packageFactor'
          },
          {
            title: '单价',
            align: 'center',
            dataIndex: 'unitprice'
          }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baHerbalMedicinePage(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('baHerbalMedicine:edit') || this.hasPerm('baHerbalMedicine:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'medicineid': record.medicineid }]
        this.baHerbalMedicineDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'medicineid': d }
        })
        this.baHerbalMedicineDelete(paramIds)
      },
      baHerbalMedicineDelete (record) {
        baHerbalMedicineDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'medicineid': d }
        })
        baHerbalMedicineExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
